import { Injectable } from '@angular/core';



@Injectable()
export class ErrorService {
  // Error dialog
  showErrorMessageDialog = false;
  errorMessage = '';
  // Working dialog
  showWorkingDialog = false;
  workingMessage = '';



  constructor() {
  }



  // Called when the error popup is closed
  resetErrorMessageDialog() {
    this.showErrorMessageDialog = false;
    this.errorMessage = '';
  }



  // Called to show the popup
  showErrorMessage(messageToShow) {
    this.errorMessage = messageToShow;
    this.showErrorMessageDialog = true;
  }



  // Called when the error popup is closed
  resetWorkingDialog() {
    this.showWorkingDialog = false;
    this.workingMessage = '';
  }



  // Called to show the popup
  showWorking(messageToShow) {
    this.workingMessage = messageToShow;
    this.showWorkingDialog = true;
  }




  
}
